import { render, staticRenderFns } from "./OrganizationDashboardCollaborators.vue?vue&type=template&id=8574ef86&scoped=true"
import script from "./OrganizationDashboardCollaborators.vue?vue&type=script&lang=js"
export * from "./OrganizationDashboardCollaborators.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDashboardCollaborators.vue?vue&type=style&index=0&id=8574ef86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8574ef86",
  null
  
)

export default component.exports